import { ADD_ALLOCATION_WISH_REQUEST } from './constants';

export const addWish = (allocationId, wish, slug, successFunction) => ({
  type: ADD_ALLOCATION_WISH_REQUEST,
  wish,
  allocationId,
  slug,
  successFunction
});
